import { render } from "./GitCheatsheet.vue?vue&type=template&id=50ef7bca&scoped=true&ts=true"
import script from "./GitCheatsheet.vue?vue&type=script&lang=ts"
export * from "./GitCheatsheet.vue?vue&type=script&lang=ts"

import "./GitCheatsheet.vue?vue&type=style&index=0&id=50ef7bca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ef7bca"]])

export default __exports__